import { TicketInfo } from 'src/models/InvoiceModel';
import { ProductModel } from 'src/models/ProductModel';
import { FORM } from 'src/constants/Form';
import FormTextField from 'src/components/Control/FormControls/FormTextField';
import IdentifierSelector from 'src/components/Control/IdentifierSelector';
import Row from 'src/components/UI/Row';
import Col2 from 'src/components/UI/Col2';
import Subtitle from 'src/components/UI/Subtitle';

interface Props {
  product: ProductModel;
  tickets: TicketInfo[];
  onChange: (tickets: TicketInfo[]) => void;
  eventId?: number;
  disabled?: boolean;
}

const TicketInformationFields = (props: Props) => {
  const {
    product, tickets, onChange, eventId, disabled,
  } = props;

  const hasAnyField = !!product.first_name_required
    || !!product.last_name_required
    || !!product.email_required
    || !!product.phone_required
    || !!product.identifier_required;

  if (!hasAnyField || tickets.length === 0) {
    return null;
  }

  const handleFieldChange = (index: number, field: string, value: string) => {
    const updated = tickets.map((ticket, i) => {
      if (i !== index) return ticket;
      return { ...ticket, [field]: value };
    });
    onChange(updated);
  };

  const hasNameFields = !!product.first_name_required || !!product.last_name_required;
  const hasContactFields = !!product.email_required || !!product.phone_required;

  return (
    <>
      <Subtitle>Ticket Information</Subtitle>
      {tickets.map((ticket, index) => (
        <div key={`ticket-${index}`} style={{ marginBottom: '16px' }}>
          {tickets.length > 1 && (
            <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
              Ticket #{index + 1}
            </div>
          )}
          {hasNameFields && (
            <Row height="auto">
              {!!product.first_name_required && (
                <Col2>
                  <FormTextField
                    form={FORM.admin_donation}
                    label="First Name"
                    name={`tickets[${index}].first_name`}
                    onChange={(val) => handleFieldChange(index, 'first_name', val)}
                    value={ticket.first_name || ''}
                    disabled={disabled} />
                </Col2>
              )}
              {!!product.last_name_required && (
                <Col2>
                  <FormTextField
                    form={FORM.admin_donation}
                    label="Last Name"
                    name={`tickets[${index}].last_name`}
                    onChange={(val) => handleFieldChange(index, 'last_name', val)}
                    value={ticket.last_name || ''}
                    disabled={disabled} />
                </Col2>
              )}
            </Row>
          )}
          {hasContactFields && (
            <Row height="auto">
              {!!product.email_required && (
                <Col2>
                  <FormTextField
                    form={FORM.admin_donation}
                    label="Email"
                    name={`tickets[${index}].email`}
                    onChange={(val) => handleFieldChange(index, 'email', val)}
                    value={ticket.email || ''}
                    disabled={disabled} />
                </Col2>
              )}
              {!!product.phone_required && (
                <Col2>
                  <FormTextField
                    form={FORM.admin_donation}
                    label="Phone"
                    name={`tickets[${index}].phone`}
                    onChange={(val) => handleFieldChange(index, 'phone', val)}
                    value={ticket.phone || ''}
                    disabled={disabled} />
                </Col2>
              )}
            </Row>
          )}
          {!!product.identifier_required && (
            <Row height="auto">
              <Col2>
                <IdentifierSelector
                  identifiersString={product.identifiers || ''}
                  eventId={eventId}
                  productId={product.id}
                  value={ticket.identifiers}
                  onChange={(val) => handleFieldChange(index, 'identifiers', val)}
                  form={FORM.admin_donation}
                  name={`tickets[${index}].identifiers`}
                  disabled={disabled} />
              </Col2>
            </Row>
          )}
        </div>
      ))}
    </>
  );
};

export default TicketInformationFields;
